const lowerFirst = function(str) {
    return str.charAt(0).toLowerCase() + str.substring(1);
};

export default lowerFirst;
//# sourceMappingURL=lowerFirst.js.map
